import styled from '@emotion/styled';

import { RichHeading } from '@/components/common/Heading';
import { HeadingLevel } from '@/components/common/MarkUp';
import { PortableText } from '@/components/common/utils';
import { bodyLarge } from '@/styles/typography';

import type { BlockWithAudience } from '@/types/shared';
import type { SanityBlock, SanityKeyed } from 'sanity-codegen';

interface OverviewProps extends BlockWithAudience {
  heading?: Array<SanityKeyed<SanityBlock>>;
  body?: Array<SanityKeyed<SanityBlock>>;
}

export const Overview = ({
  heading,
  body,
  pageAudience,
  isAudienceSwitcherEnabled,
}: OverviewProps) => {
  if (heading.length || body.length) {
    return (
      <>
        <HeadingLevel>
          <HeadingWrapper>
            <RichHeading heading={heading} size="heading-md" />
          </HeadingWrapper>
        </HeadingLevel>
        <OverviewParagraph>
          <PortableText
            value={body}
            audienceConfig={{ pageAudience, isAudienceSwitcherEnabled }}
          />
        </OverviewParagraph>
      </>
    );
  }

  return null;
};

const HeadingWrapper = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: var(--font-weight-semibold);
  }
`;

const OverviewParagraph = styled.div`
  margin-top: var(--space-component-xl);

  p:not(:first-of-type) {
    padding-top: var(--space-component-lg);
  }
  p {
    color: var(--text-warm-base);
    ${bodyLarge}
  }
`;
